module.exports = __webpack_public_path__ + "static/media/Hochzeitseinladung-1.88c4acfe.png";